<template>
  <div class="row text-tab">
    <div
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      class="flex flex-center"
    >
      <span v-if="index" class="q-mx-sm">/</span>
      <SAILink
        v-bind="$attrs"
        :class="{ 'text-uppercase': !noCaps }"
        :href="crumb.to"
        :color="color"
        :disable-color="color"
        :label="crumb.label"
        :disable="index >= breadcrumbs.length - 1"
      />
    </div>
  </div>
</template>

<script>
/**
 * Render a list of breadcrumbs
 * A breadcrumb object should be defined as:
 * {
 *   label: String,
 *   to: Vuex to object
 * }
 */
export default {
  name: 'SAIBreadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: 'grey-8'
    },
    noCaps: Boolean
  },
  components: {
    SAILink: () => import('../../atom/sai-link')
  }
};
</script>
